module.exports = "<biermi-process [steps]=\"steps\" [step]=\"step\"></biermi-process>"